import React from 'react';
import {Switch} from "react-router";
import {BrowserRouter as Router, Route} from 'react-router-dom';
import * as DomUtils from "./utils/dom-utils";
import './common/font-awesome-library';
import './Workbench.scss';

import WorkbenchBootstrap from "./components/bootstrap/WorkbenchBootstrap";
import {WorkbenchRoute} from "./common/WorkbenchRoute";
import {Error404} from "./pages/error/Error404";
import Layout from "./pages/Layout";
import GenerateSchemaPage from "./pages/generate/GenerateSchemaPage";
import HomePage from "./pages/home/HomePage";
import HelpPage from "./pages/help/HelpPage";
import SchemaRegistryPage from "./pages/registry/SchemaRegistryPage";
import SchemaPlaygroundPage from "./pages/schema/SchemaPlaygroundPage";
import ManageSchemaPage from "./pages/schema/ManageSchemaPage";
import UploadSchemaPage from "./pages/upload/UploadSchemaPage";
import CreateSchemaPage from "./pages/create/CreateSchemaPage";
import {MonitoringPage} from "./pages/monitor/MonitoringPage";
import GraphQLPage from "./pages/graphql/GraphQLPage";
import SearchPage from "./pages/search/SearchPage";
import ObjectViewPage from "./pages/object/ObjectViewPage";

/**
 * The main component that bootstraps the Workbench layout and pages.
 */
class Workbench extends React.Component {

  private readonly basename: string;

  constructor(props: {}) {
    super(props);
    this.basename = DomUtils.getBasePath() || '/';
  }

  render() {
    return (
      <div className="Workbench">
        <WorkbenchBootstrap>
          <Router basename={this.basename}>
            <Layout>
              <React.Fragment>
                <Switch>
                  <Route path="/reload" component={undefined} key="reload"/>
                  <WorkbenchRoute exact path="/" pageTitle="" component={HomePage}/>
                  <WorkbenchRoute exact path="/schemas" pageTitle="Schemas"
                                  component={SchemaRegistryPage}/>
                  <WorkbenchRoute path="/schema/create" pageTitle="Create Schema"
                                  component={CreateSchemaPage}/>
                  <WorkbenchRoute path="/schema/generate" pageTitle="Generate Schema"
                                  component={GenerateSchemaPage}/>
                  <WorkbenchRoute path="/schema/upload" pageTitle="Upload Schema"
                                  component={UploadSchemaPage}/>
                  <WorkbenchRoute path="/schema/manage" pageTitle="Manage Schema"
                                  render={(props) => <ManageSchemaPage {...props}
                                                                       key={Math.random()}/>}/>
                  <WorkbenchRoute exact path="/schema/playground" pageTitle="Playground"
                                  component={SchemaPlaygroundPage}/>
                  <WorkbenchRoute exact path="/graphql" pageTitle="GraphQL"
                                  component={GraphQLPage}/>
                  <WorkbenchRoute exact path="/search" pageTitle="Search"
                                  component={SearchPage}/>
                  <WorkbenchRoute exact path="/monitoring" pageTitle="Monitoring"
                                  component={MonitoringPage}/>
                  <WorkbenchRoute exact path="/help" pageTitle="Help" component={HelpPage}/>
                  <WorkbenchRoute exact path="/object/view" pageTitle="Object View"
                                  component={ObjectViewPage}/>
                  <WorkbenchRoute pageTitle="Error" component={Error404}/>
                </Switch>
              </React.Fragment>
            </Layout>
          </Router>
        </WorkbenchBootstrap>
      </div>
    );
  }
}

export default Workbench;
